export default {
  user_type: [
    { id: 0, title: "Passenger", label: "Passenger", value: "passenger" },
    { id: 3, title: "Driver", label: "Driver", value: "driver" }
  ],
  logo_url:"http://global.youdriveethiopia.appshub.work/logo.png",
  // favicon_url:"http://global.youdriveethiopia.appshub.work/favicon.png",
  favicon_url:"http://global.xlcab.appsworld.work/favicon.png",
};
